<template>
  <div :class="$style.box">
    <div style="height: 0.1px"></div>
    <header :class="$style.title">
      <img :src="`${$cdnUrl}/seckill/dialog/rules/jiaocheng_zhubiaoti.png`" />
    </header>
    <main :class="$style.content">
      <div :class="$style.item">
        <img :src="`${$cdnUrl}/seckill/dialog/rules/jiaocheng_diyibu.png`" />
        <p>在游戏中选择充值档位。</p>
        <img :src="`${$cdnUrl}/seckill/dialog/rules/jiaocheng_diyibupeitu.png`" />
      </div>
      <div :class="$style.item">
        <img :src="`${$cdnUrl}/seckill/dialog/rules/jiaocheng_dierbu.png`" />
        <p>在支付界面，选择要使用的代金券进行充值。代金券<span>有效期为3天</span>，请及时使用。</p>
        <img :src="`${$cdnUrl}/seckill/dialog/rules/jiaocheng_dierbupeitu.png`" />
      </div>
      <div :class="$style['third-item']">
        <img :src="`${$cdnUrl}/seckill/dialog/rules/jiaocheng_wenti.png`" />
        <p>1、在游戏内，点击屏幕左侧悬浮按钮，进入“代金券”查看。</p>
        <img :src="`${$cdnUrl}/seckill/dialog/rules/jiaocheng_wentipeitu.png`" />
        <p>2、在官方论坛，进入“个人主页-我的代金券”查看。</p>
        <img
          :src="`${$cdnUrl}/seckill/dialog/rules/${
            channelType == 'channel_hm' ? 'qudao1' : 'qudao3'
          }.png`"
        />
      </div>
    </main>
    <footer :class="$style.tips">
      <img :src="`${$cdnUrl}/seckill/dialog/rules/jinruluntan.png`" @click="handleLink" />
      <p>如有其它疑问，请联系客服咨询。</p>
    </footer>
  </div>
</template>

<script>
import { channelType } from '@/config/index';
export default {
  data() {
    return {
      channelType: channelType
    };
  },
  methods: {
    handleLink() {
      if (this.channelType == 'channel_hm') {
        this.$router.push({ name: 'gameCircleCenter.home' })
      } else {
        this.$router.push({ name: "gameCircle.home", query: { circleId: 20 } });
      }
    }
  },
}
</script>

<style lang='scss' module>
.box {
  width: 100vw;
  height: 100vh;
  padding: 16px 20px 24px 20px;
  background-color: #2c0d0e;
  overflow: auto;
  .title {
    width: 100%;
    text-align: center;
    > img {
      width: auto;
      height: 16px;
    }
  }
  .content {
    .item {
      width: 100%;
      margin-top: 13px;
      > img:first-child {
        width: auto;
        height: 13px;
      }
      > p {
        margin-top: 7px;
        margin-left: 10px;
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9b7867;
        line-height: 13px;
        > span {
          color: #edc330;
        }
      }
      > img:last-child {
        margin-top: 3px;
        margin-left: calc(50vw - 135px);
        width: 221px;
        height: 125px;
        border-radius: 4px;
      }
    }
    .third-item {
      width: 100%;
      margin-top: 13px;
      > img {
        margin-top: 3px;
        margin-left: calc(50vw - 135px);
        width: 221px;
        height: 125px;
        border-radius: 4px;
      }
      > img:first-child {
        width: auto;
        height: 13px;
        margin-left: 0;
      }
      > img:last-child {
        width: 260px;
        height: auto;
        text-align: center;
        margin-left: 35px;
      }
      > p {
        margin-top: 7px;
        margin-left: 10px;
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9b7867;
        line-height: 13px;
        > span {
          color: #edc330;
        }
      }
    }
  }
  .tips {
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: #b29e95;
    line-height: 16px;
    > img {
      width: 80px;
      margin-top: 5px;
    }
    > p {
      margin-top: 10px;
    }
  }
}
</style>
